<template>
	<div class="p-col-12 p-grid">
		<div v-if="!commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeTeam1ImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
		</div>

		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>SCOUTING</p>
			<p class="login-subtitle">Advanced player evaluation</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Our advanced algorithm not only evaluates the current value of players but also projects their future growth potential, helping clubs make informed decisions when signing both free agents and players currently under contract.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Our platform also offers a comprehensive database of available free agents, allowing clubs to easily search and identify potential signings. </p>
			<p v-if="!commonService.isMobile()" class="login-text justified">For players currently under contract, our system allows clubs to monitor their performance and progress, preparing them for the upcoming transfer window.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Our algorithmic system evaluates both the current and future growth potential of players, providing clubs with reliable information for negotiate with free agents players or those under contract. </p>
			<p v-if="commonService.isMobile()" class="login-text justified">We also offer a comprehensive database of free agents for easy searching and monitoring of players' performance to prepare for upcoming transfer windows.</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-4 button-box' : 'p-lg-2 button-box'" style="padding: 0px">
				<Button label="Start now" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>

		<div v-if="commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeTeam1ImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-4 button-box-mobile" style="margin-top: -10px; margin-bottom: 30px">
				<Button label="Start now" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>